import React, {FC} from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
} from "@mui/material";
import {IMotorcycle} from "../../../interfaces/Interfaces";
import {MotorcycleMedia} from "../details/MotorcycleMedia";
import {ButtonsGroupMotoTableCard} from "./ButtonsGroupMotoTableCard";
import {MotorcycleInfo} from "./MotorcycleInfo";
import {Link} from "react-router-dom";

interface ICatalogueListItem {
    motorcycle: IMotorcycle;
    handleDetailsClick: () => void;
    handleCompareClick: () => void;
    handleToggleFavorite: () => void;
    isInCompareList: boolean;
    isFavourite: boolean;
    compareArrayLength: number;
    navigateToDetailsPath: string;
    navigateToComparePath: string;
    isSmallScreen: boolean;
}

export const CatalogueListItem: FC<ICatalogueListItem> = ({
    motorcycle,
    handleDetailsClick,
    handleCompareClick,
    handleToggleFavorite,
    isInCompareList,
    isFavourite,
    compareArrayLength,
    navigateToDetailsPath,
    navigateToComparePath,
    isSmallScreen,
}) => (
    <Card
        sx={{
            display: "flex",
            flexDirection: {xs: "column", sm: "row"},
            width: "100%",
            boxShadow: 2,
            position: "relative",
            transition: "background-color 0.3s, transform 0.3s",
            backgroundColor: (theme) => theme.palette.card.background,
            "&:hover": {
                backgroundColor: (theme) => theme.palette.card.secondary,
                transform: "scale(1.01)",
            },
            "&:hover button": {
                opacity: 1,
                transform: "translateY(0)",
            },
        }}
    >
        <Box
            sx={{
                position: "relative",
                width: {xs: 120, sm: 120},
                height: {xs: 120, sm: 120},
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: {xs: 2, sm: 2},
            }}
            component="a"
            href={navigateToDetailsPath}
            onClick={handleDetailsClick}
        >
            <MotorcycleMedia motorcycle={motorcycle}/>
        </Box>
        <CardContent sx={{padding: "10px", flexGrow: 1}}>
            <Link
                to={navigateToDetailsPath}
                style={{textDecoration: "none", color: "inherit"}}
            >
                <Typography
                    variant="h6"
                    component="div"
                    gutterBottom
                    onClick={handleDetailsClick}
                    sx={{
                        display: "inline-block",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: {xs: "400px", sm: "300px", lg: "600px"},
                    }}
                >
                    {motorcycle.makerName} {motorcycle.modelName}
                </Typography>

            </Link>
            <MotorcycleInfo motorcycle={motorcycle}/>
        </CardContent>
        <Box
            sx={{
                position: "absolute",
                top: 10,
                right: 10,
            }}
        >
            <ButtonsGroupMotoTableCard
                handleCompareClick={handleCompareClick}
                handleToggleFavorite={handleToggleFavorite}
                isInCompareList={isInCompareList}
                isFavourite={isFavourite}
                compareArrayLength={compareArrayLength}
                navigateToDetailsPath={navigateToDetailsPath}
                navigateToComparePath={navigateToComparePath}
                mobileMode={isSmallScreen}
            />
        </Box>
    </Card>
);
